export default __webpack_public_path__ + "static/media/background-video.66e998b4.mp4";